import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#basic-usage" }),
  /*#__PURE__*/_createTextVNode(" Basic usage ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, " The basic use case is using this component to provide unified space between each components ", -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { class: "card-header" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", null, "Card name", -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Operation button")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_space = _resolveComponent("el-space")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_space, { wrap: "" }, {
        default: _withCtx(() => [
          (_openBlock(), _createBlock(_Fragment, null, _renderList(3, (i) => {
            return _createVNode(_component_el_card, {
              class: "box-card",
              style: {"width":"250px"},
              key: i
            }, {
              header: _withCtx(() => [
                _createVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_el_button, {
                    class: "button",
                    type: "text"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  })
                ])
              ]),
              default: _withCtx(() => [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(4, (o) => {
                  return _createVNode("div", {
                    key: o,
                    class: "text item"
                  }, _toDisplayString("List item " + o), 1)
                }), 64))
              ]),
              _: 2
            }, 1024)
          }), 64))
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code1), 1)
        ]),
        _: 1
      })
    ])
  ]))
}